import { motion } from "framer-motion";
import { waLink, WA_MSG } from "../data/content";
import { WhatsAppIcon } from "./Navbar";

export default function WhatsAppFloat() {
  return (
    <motion.a
      href={waLink(WA_MSG)}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-float"
      aria-label="Chat with The Big Wedd on WhatsApp"
      initial={{ opacity: 0, scale: 0 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ delay: 1.6, duration: 0.5 }}
      className="fixed bottom-6 right-6 z-[80] group"
    >
      <span className="absolute inset-0 rounded-full bg-gold animate-pulse-ring" />
      <span className="relative flex h-14 w-14 items-center justify-center rounded-full bg-emerald text-ivory shadow-xl shadow-emerald/30 transition-transform duration-300 group-hover:scale-110">
        <WhatsAppIcon className="h-6 w-6" />
      </span>
      <span className="pointer-events-none absolute right-full top-1/2 mr-3 -translate-y-1/2 whitespace-nowrap rounded-full bg-ink px-4 py-2 text-[11px] uppercase tracking-[0.15em] text-ivory opacity-0 transition-opacity duration-300 group-hover:opacity-100 hidden md:block">
        Chat on WhatsApp
      </span>
    </motion.a>
  );
}
